import { PANTONE_FABRIC_CONFIG } from 'commons/constants';

const { fabricMappingOverrides } = PANTONE_FABRIC_CONFIG;

export default function getMaterialNameFromSlug(materialSlug) {
  if (!materialSlug) {
    return 'Bentley Daisey';
  }

  // Check if this slug matches any of the Pantone fabrics in the mapping overrides
  const pantoneMapping = fabricMappingOverrides?.find(
    item => item.swatchPageSlug === materialSlug
  );

  // If we found a match in the mappings, return the proper name
  if (pantoneMapping) {
    return pantoneMapping.name;
  }

  // For non-Pantone fabrics, continue with the standard formatting
  return materialSlug
    .split('-')
    .map(word => word[0].toUpperCase() + word.substring(1).toLowerCase())
    .join(' ');
}
